import { PaginationResult } from "../../../../Shared/Model/PaginationResult";
import { Offers } from "../Model/Offers";
import { OffersPromoRepository } from "../Repository/OffersPromoRepository";

export interface GetOffersUseCase {
  invoke: (page: number, pageSize: number, search: string, typeOfferImage: number ) => Promise<PaginationResult<Offers>>;
}

export class GetOffers implements GetOffersUseCase {
  private Repo: OffersPromoRepository;
  constructor(_Repo: OffersPromoRepository) {
    this.Repo = _Repo;
  }

   invoke(page: number, pageSize: number, search: string, typeOfferImage: number){
    const getData = this.Repo.getOffers(page, pageSize, search, typeOfferImage);
    return getData;
  }
}